import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bulk-update-move-status',
  templateUrl: './bulk-update-move-status.component.html',
  styleUrls: ['./bulk-update-move-status.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUpdateMoveStatusComponent {
  /* table  */
  displayedColumns: string[] = [
    'oldProductValue',
    'newProductValue',
  ];
  dataSource: any;
  showToListButton: boolean = false;

  /* resource keys */
  title = 'OrganizationDetails.BulkUpdate.Status.Title'; 
  subtitle = 'OrganizationDetails.BulkUpdate.Status.Subtitle';
  exportFileName = 'Bulk_Update_Summary_Export' + new Date().toISOString();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { results: any[]; },
    public dialogRef: MatDialogRef<
      BulkUpdateMoveStatusComponent,
      { sendToList: boolean }
    >,
    public router: Router,
  ) {
    dialogRef.disableClose = true;
    this.initializeForm(data);
  }

  onCloseButtonClick() {
    this.dialogRef.close({ sendToList: false });
  }

  onToListButtonClick() {
    //apply the filter to the tanks list then navigate to the tanks list page
    this.dialogRef.close({ sendToList: true });
  }

  private initializeForm(data: any) {
    this.dataSource = data?.results ?? [];
    this.showToListButton = data?.showToListButton ?? false;
  }

}
